import.meta.glob([ '../images/**', ])
import { createApp } from 'vue';

import CookieComply from './components/cookie-comply/CookieComply.vue';
import Map from './components/Map.vue';

const cookieComplyElement = document.getElementById('cookie-comply');

if (cookieComplyElement) {
    const companyName = cookieComplyElement.dataset.companyName;
    const privacyPolicyUrl = cookieComplyElement.dataset.privacyPolicyUrl;
    const language = cookieComplyElement.dataset.language;
    
    const cookie = createApp(CookieComply, {
        companyName,
        privacyPolicyUrl,
        language
    });
    cookie.mount('#cookie-comply');
}


import('bootstrap')

const mapElement = document.getElementById('map');

if(mapElement) {
    import('leaflet/dist/leaflet.css');
    const markers = mapElement.dataset.markers;
    const zoom = mapElement.dataset.zoom;
    
    const osmMAP = createApp(Map, {
        markers,
        zoom,
    });

    osmMAP.mount('#map');
}

